module.exports = __webpack_public_path__ + "static/tulips-db2d41f194c9dc387f7446d65bd2a6f7.jpg";